import type {StaffIdCard} from '@/utils/IdCard.ts';
import type * as React from 'react';
import SvgText from '../../../components/SvgText';
import Barcode from '../Barcode';

type Props = {
    idCard: StaffIdCard;
    width: string;
};

const StaffFront: React.FC<Props> = ({idCard, width = '100%'}: Props) => {
    return (
        <svg viewBox='0 0 800 1200' width={width}>
            <title id={`staff-front-${idCard.id}`}>Staff Front for ID {idCard.id}</title>
            <defs>
                <clipPath id='card'>
                    <rect x={0} y={0} width={800} height={1200} rx={50} ry={50} />
                </clipPath>
            </defs>

            <image
                href={`data:image/jpeg;base64,${idCard.backgroundImage}`}
                width={800}
                height={1200}
                x={0}
                y={0}
                clipPath='url(#card)'
                preserveAspectRatio='xMinYMin slice'
            />

            <image
                href={`data:image/jpeg;base64,${idCard.schoolBanner}`}
                width={375}
                height={165}
                x={212.5}
                y={60}
            />
            <rect x={220} y={260} width={360} height={540} fill='white' />
            <image
                href={`data:image/jpeg;base64,${idCard.photo}`}
                width={360}
                height={540}
                x={220}
                y={260}
            />

            <SvgText
                blocks={[idCard.name]}
                x={400}
                y={810}
                fontSize={70}
                fontWeight='bold'
                width={400}
                textAnchor='middle'
                fill={`#${idCard.textColor}`}
            />

            <rect x={60} y={980} width={680} height={180} fill='white' />

            <Barcode idCard={idCard} transform='translate(400, 1000)' withoutRoot anchor='middle' />
        </svg>
    );
};

export default StaffFront;
